import classNames from 'clsx';
import React, { memo, useRef } from 'react';
import { Input } from 'reactApp/components/BaseConfirmDialog/Input/Input';
import { DropdownFont, DropdownList, DropdownTheme } from 'reactApp/ui/DropdownList/DropdownList';
import { IProps } from 'reactApp/ui/InputSuggest/InputSuggest.types';
import { useCallbacks } from 'reactApp/ui/InputSuggest/useCallbacks';

import styles from './InputSuggest.css';

export const InputSuggest = memo<IProps>(
    ({
        value,
        focus,
        disabled,
        hasError,
        onChange,
        action,
        theme,
        placeholder,
        renderSuggestionItem,
        suggestions = [],
        onRequestSuggestions,
        getSuggestionItemId,
    }) => {
        const inputRef = useRef<HTMLInputElement | null>(null);

        const { handleInputKeyDown, closeDropdown, handleChange, calcDropdownPosition, renderItem, showDropdown, list } = useCallbacks({
            suggestions,
            onChange,
            getSuggestionItemId,
            inputRef,
            renderSuggestionItem,
            onRequestSuggestions,
            disabled,
        });

        const getReference = (ref) => {
            inputRef.current = ref;
        };

        return (
            <div className={styles.root}>
                <Input
                    error={Boolean(hasError)}
                    onChange={handleChange}
                    onKeyDown={handleInputKeyDown}
                    value={value}
                    focus={focus}
                    placeholder={placeholder}
                    fluid
                    getReference={getReference}
                    disabled={disabled}
                    className={classNames(styles.input, {
                        [styles[`input_${theme}`]]: Boolean(theme),
                        [styles.input_right_action]: Boolean(action),
                        [styles.input_error]: hasError,
                    })}
                />
                {Boolean(action) && action}
                {showDropdown && (
                    <DropdownList
                        list={list}
                        renderItem={renderItem}
                        close={closeDropdown}
                        theme={DropdownTheme.suggest}
                        parentRef={inputRef}
                        closeOnItemClick
                        font={DropdownFont.mailSans}
                        gaId="suggest"
                        calcPosition={calcDropdownPosition}
                    />
                )}
            </div>
        );
    }
);

InputSuggest.displayName = 'InputSuggest';
